import { render, staticRenderFns } from "./finiquito.vue?vue&type=template&id=69c1d55d&"
import script from "./finiquito.component.ts?vue&type=script&lang=ts&"
export * from "./finiquito.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports